<template>
  <header id="NavBar">
    <router-link :to="{ name: 'Index' }">
      <img src="@/assets/images/brand.svg" alt="Industrie ACL">
    </router-link>
    <nav id="Menu" class="hide-mobile">
      <router-link :to="{ name: 'Services.Cintrage' }">Services et équipements</router-link>
      <router-link :to="{ name: 'RealisationsPage' }">Réalisations</router-link>
      <router-link :to="{ name: 'AboutUs' }">À propos</router-link>
    </nav>
    <div @click="sideNavSwitch()" class="only-mobile HamburgerButton"><div class="bar"></div><div class="bar"></div><div class="bar"></div></div>
    <transition name="SideNav">
      <nav id="SideNav" class="only-mobile" v-show="isSideNav">
        <div @click="sideNavSwitch()" class="xButton"><div class="bar"></div><div class="bar"></div></div>
        <router-link :to="{ name: 'Index' }" @click.native="sideNavSwitch()">Acceuil</router-link>
        <router-link :to="{ name: 'Services.Cintrage' }" @click.native="sideNavSwitch()">Services et équipements</router-link>
        <router-link :to="{ name: 'RealisationsPage' }" @click.native="sideNavSwitch()">Réalisations</router-link>
        <router-link :to="{ name: 'AboutUs' }" @click.native="sideNavSwitch()">À propos</router-link>
      </nav>
    </transition>
    <transition name="SideBarOverlay">
      <div class="overlay" v-show="isSideNav" @click="sideNavSwitch()"></div>
    </transition>
  </header>
</template>

<script>
export default {
  data () {
    return {
      isSideNav: false
    }
  },
  methods: {
    sideNavSwitch () {
      this.isSideNav = !this.isSideNav
    }
  }
}
</script>

<style lang="scss">
.SideNav-enter-active { animation: SideNavEnter .4s; }
.SideNav-leave-active { animation: SideNavLeave .4s; }

.SideBarOverlay-enter-active { animation: OverlayEnter .5s; }
.SideBarOverlay-leave-active { animation: OverlayLeave .5s; }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue